import React from "react";
import { useState, useEffect } from "react";
import "./Inicio.scss";
import {
  Button,
  Grid,
  Image,
  Transition,
  Dimmer,
  Loader,
} from "semantic-ui-react";
import { Link } from "react-router-dom";

import imagen from "../../images/imagenHomeAgenda.jpg";

export function Inicio() {
  const [imagenCargada, setImagenCargada] = useState(false);

  const [activado, setActivado] = useState(false);

  const cargaImagen = () => {
    setImagenCargada(true);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
    });
  };

  useEffect(() => {
    setActivado((a) => !a);
    scrollToTop();
  }, []);

  return (
    <>
      <Dimmer active={!imagenCargada} inverted>
        <Loader>Espere un momento</Loader>
      </Dimmer>

      <Grid
        className="gridInicio"
        stackable
        columns={2}
        verticalAlign="middle"
        textAlign="center"
        style={{
          display: imagenCargada ? "flex" : "none",
        }}
      >
        <Transition animation="fade right" duration={2000} visible={activado}>
          <Grid.Column style={{ padding: "40px" }}>
            <p className="tituloGrande">MINISTERIO DE SALUD DE JUJUY</p>
            <p className="tituloMediano">UNIDAD DE DOCENCIA Y CAPACITACIÓN</p>
            <p className="tituloPequenio">AGENDA ÚNICA DE CAPACITACIÓN</p>
            <Button className="buttonFormat" as={Link} to={"/agenda"}>
              Ir a la Agenda
            </Button>
          </Grid.Column>
        </Transition>

        <Grid.Column style={{ padding: "15px" }}>
          <Transition animation="fade left" duration={2000} visible={activado}>
            <Image
              className="imagenHome"
              centered
              src={imagen}
              onLoad={cargaImagen}
            />
          </Transition>
        </Grid.Column>
      </Grid>
    </>
  );
}
